<footer
  class="gw-mt-auto gw-w-full gw-max-w-[100vw] gw-overflow-x-hidden gw-border-t gw-border-border-soft gw-bg-background-base gw-px-medium gw-py-medium gw-box-border md:gw-px-large md:gw-py-2x-large [@media(max-height:720px)]:md:gw-py-medium [@media(max-height:720px)]:lg:gw-py-small"
>
  <div
    class="gw-flex gw-w-full gw-min-w-0 gw-max-w-6xl gw-flex-col gw-flex-wrap gw-items-center gw-justify-between gw-gap-medium gw-text-center gw-mx-auto md:gw-flex-row md:gw-items-center md:gw-justify-between md:gw-text-left [@media(max-height:720px)]:md:gw-gap-small [@media(max-height:720px)]:lg:gw-gap-x-small"
  >
    <p
      class="gw-order-2 gw-max-w-full gw-min-w-0 gw-text-balance gw-text-[11px] gw-font-medium gw-leading-relaxed gw-tracking-[0.12em] gw-text-text-tertiary md:gw-order-1 md:gw-flex-1"
    >
      <ng-container *ngIf="copyrightLine; else defaultCopy">
        {{ copyrightLine }}
      </ng-container>
      <ng-template #defaultCopy>
        <span class="gw-uppercase">© {{ year }}</span>
        <span
          *ngIf="siteTitle"
          class="gw-ml-1 gw-font-semibold gw-text-text-secondary"
        >
          {{ siteTitle }}
        </span>
      </ng-template>
    </p>

    <nav
      class="gw-order-1 gw-flex gw-w-full gw-max-w-full gw-min-w-0 gw-flex-wrap gw-items-center gw-justify-center gw-gap-x-medium gw-gap-y-small md:gw-order-2 md:gw-w-auto md:gw-max-w-[min(100%,24rem)] md:gw-shrink md:gw-justify-end"
      [attr.aria-label]="'features.loginPage.footer.navAria' | translate"
    >
      <a
        *ngIf="termsUrl"
        [href]="termsUrl"
        target="_blank"
        rel="noopener noreferrer"
        class="gw-inline-flex gw-max-w-full gw-items-center gw-gap-x-small gw-whitespace-normal gw-text-center gw-text-[11px] gw-font-semibold gw-uppercase gw-tracking-[0.14em] gw-text-text-secondary gw-transition-colors hover:gw-text-text-primary"
      >
        <gatewee-icon
          icon="@phi.file-text"
          size="14px"
          class="gw-shrink-0 gw-text-text-tertiary"
        ></gatewee-icon>
        {{ 'features.loginPage.footer.terms' | translate }}
      </a>
      <a
        *ngIf="privacyUrl"
        [href]="privacyUrl"
        target="_blank"
        rel="noopener noreferrer"
        class="gw-inline-flex gw-max-w-full gw-items-center gw-gap-x-small gw-whitespace-normal gw-text-center gw-text-[11px] gw-font-semibold gw-uppercase gw-tracking-[0.14em] gw-text-text-secondary gw-transition-colors hover:gw-text-text-primary"
      >
        <gatewee-icon
          icon="@phi.shield-check"
          size="14px"
          class="gw-shrink-0 gw-text-text-tertiary"
        ></gatewee-icon>
        {{ 'features.loginPage.footer.privacy' | translate }}
      </a>
      <a
        routerLink="/documentation"
        target="_blank"
        class="gw-inline-flex gw-max-w-full gw-items-center gw-gap-x-small gw-whitespace-normal gw-text-center gw-text-[11px] gw-font-semibold gw-uppercase gw-tracking-[0.14em] gw-text-text-secondary gw-transition-colors hover:gw-text-text-primary"
      >
        <gatewee-icon
          icon="@phi.book-open-text"
          size="14px"
          class="gw-shrink-0 gw-text-text-tertiary"
        ></gatewee-icon>
        {{ 'features.loginPage.footer.apiDocs' | translate }}
      </a>
    </nav>
  </div>
</footer>
